import { render, staticRenderFns } from "./PreviewBackgroundModal.vue?vue&type=template&id=1f5d707a&scoped=true"
import script from "./PreviewBackgroundModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewBackgroundModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreviewBackgroundModal.vue?vue&type=style&index=0&id=1f5d707a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d707a",
  null
  
)

export default component.exports